import {
    AUTH
  } from "../reducers/actions/types/types";
  
  
  const initialState = {
    user : [],
    isLoggedIn : false,
    token : [],
  }
  
  export default function (state = initialState, action) {
    const { type, payload } = action;
  
    switch (type) {
      case AUTH.REGISTER_SUCCESS:
        return {
          ...state,
          isLoggedIn: false,
        };
      case AUTH.REGISTER_FAIL:
        return {
          ...state,
          isLoggedIn: false,
        };
      case AUTH.LOGIN_SUCCESS:
        return {
          ...state,
          isLoggedIn: true,
          token: payload.token.accessToken,
        };
      case AUTH.LOGIN_FAIL:
        return {
          ...state,
          isLoggedIn: false,
          user: null,
        };
      case AUTH.LOGOUT:
        return {
          ...state,
          user:[],
          token: null,
          isLoggedIn : false,
        };

     case AUTH.USER_INFORMATION:
        return {
          ...state,
          user : payload.user ,
        };

      default:
        return state;
    }
  }